import { render, staticRenderFns } from "./TeacherAccessibleStudentPageUpload.vue?vue&type=template&id=1e283298&"
import script from "./TeacherAccessibleStudentPageUpload.vue?vue&type=script&lang=ts&"
export * from "./TeacherAccessibleStudentPageUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports